// @flow
import React from 'react';
import PropTypes from 'prop-types';
import HelpLink from "./HelpLink";
import LIButton from "./LIButton";

const TextInput = ({name, refName, label, onChange, onReturnPressed, placeholder, value, helpText, helpLink,
                       required, goodNess, autoComplete, 
                       minLength, maxLength, focus, readOnly, widthPels, textLeft, 
                       oneRow, inputWidthPels, huge, disabled=false, showClearButton, tabIndex, isPassword=false}) => {
    let inputClass = 'li-form-field li-border-dark';
    if(oneRow) {
        inputClass += ' remove-w-100';
    }
    if(textLeft) {
        inputClass += ' text-left';
    }
    else {
        inputClass += ' text-center';
    }
    if(!disabled &&goodNess && goodNess==="bad") {
        inputClass += ' li-border-danger';
    }
    else if(!disabled && goodNess && goodNess==="good") {
        inputClass += ' li-border-good' ;
    }
    if(readOnly) {
        inputClass += ' li-bg-muted';
    }
    let styleInfo={};
    if(widthPels) {
        styleInfo={"width":widthPels.toString()+"px"};
    }
    if(!autoComplete) {
        autoComplete= "off";
    }
    let inputStyleInfo = {};
    if(inputWidthPels) {
        inputStyleInfo = {"width":inputWidthPels.toString()+"px"};
    }
    if(huge) {
        inputClass+= " huge";
    }
    
    function gotKeyDown(event) {
        if(event.key === "Enter") {
            if(onReturnPressed) {
                event.preventDefault();
                onReturnPressed();
            }
        }
    }
    
    return(
      <div className={"form-group m-0"} style={styleInfo} >
          {label && label!==''?<label className={"li-form-label "+(oneRow?"mr-3":"")} htmlFor={name}>{label}</label>:null}
          {helpLink && helpLink!==''?<HelpLink link={helpLink} small/>:null}
          <input style={inputStyleInfo}
                  id={name}
                  type={isPassword ? "password" : "text"}
                  name={name}
                  className={inputClass}
                  placeholder={placeholder}
                  value={value}
                  onChange={onChange} onKeyDown={gotKeyDown}
                  required={required && 'required'} 
                  autoComplete={autoComplete}
                  minLength={minLength} 
                  maxLength={maxLength}
                  autoFocus={focus}
                  readOnly={readOnly}
                  ref={refName}
                  disabled={disabled}
                  tabIndex={tabIndex}
              />
          {showClearButton && <LIButton bgClass="ml-1 li-bg-primary li-fg-white" faIcon="fa fa-times-circle" small onClick={
              (e) => {
                  e.preventDefault();
                  const syntheticEvent = {
                      target: {
                          name: name,
                          value: ""
                      }
                  };
                  onChange(syntheticEvent);
              }
          }/>}
          {helpText && helpText!=="" && <small className="form-text mt-0 text-muted">{helpText}</small>}
      </div>
    );
}

TextInput.propTypes = {
    name: PropTypes.string.isRequired,
    refName: PropTypes.object,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onReturnPressed: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    helpText: PropTypes.string,
    helpLink: PropTypes.string,
    required: PropTypes.bool,
    goodNess: PropTypes.string,
    autoComplete: PropTypes.string,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    focus: PropTypes.bool,
    readOnly: PropTypes.bool,
    widthPels: PropTypes.number,
    textLeft: PropTypes.bool,
    oneRow: PropTypes.bool,
    inputWidthPels: PropTypes.number,
    huge: PropTypes.bool,
    disabled: PropTypes.bool,
    showClearButton: PropTypes.bool,
    tabIndex: PropTypes.number,
    isPassword: PropTypes.bool
};

export default TextInput;